<template>
  <div class="contentbox" v-if="webConfig">
    <div class="logo">
      <img src="/static/img/logo.jpg" width="192" alt="" @click="$router.push('/')">
    </div>
    <!-- <div class="header">
      <div class="headerbox">
        <img :src="`${IP_TEST}/uploads/${webConfig.logopic}`" alt="" @click="$router.push('/')">
        <div class="back">
            <a class="light" href="/inquery">继续查询</a>
            <a href="/">返回页面</a>
        </div>
        
      </div>
      
    </div> -->
    <div class="show" v-if="showInfo">
      <div class="box">
        <div class="toplogo">
          <h1>证书查询结果页</h1>
        </div>
        <div class="theader">个人信息</div>
        <!-- <div class="tip">根据中国专家智库网人才入库审核标准，经评定！信息符合职业技术人才入库审核标准，同意您加入专家智库。</div> -->
        <table class="personInfo" style="margin-top: 28px;">
          <!-- <tr class="theader">
          <th colspan="5">
            证书查询结果页
          </th>
        </tr> -->

          <tr>
            <td colspan="2" style="text-align:center;">{{ showInfo.name }}</td>
            <td rowspan="6" style="padding:83px 76px 61px 95px;width:293px;">
              <img :src="`/uploads/xlsfile/usepic/${showInfo.picsrc}`" alt="">
            </td>
          </tr>
          <tr>
            <td style="width: 179px;text-align:center;">性别</td>
            <td>{{ showInfo.sex }}</td>
          </tr>
          <tr>
            <td style="width: 179px;text-align:center;">民族</td>
            <td>民族</td>
          </tr>
          <tr>
            <td style="width: 179px;text-align:center;">国籍</td>
            <td>中国</td>
          </tr>
          <tr>
            <td style="width: 179px;text-align:center;">证件类型</td>
            <td>{{ showInfo.cardtype }}</td>
          </tr>
          <tr>
            <td style="width: 179px;text-align:center;">证件号码</td>
            <td>{{ showInfo.cardtid }}</td>
          </tr>
          <tr>
            <td colspan="3" style="text-align:center;color:#FFC21C;font-size: 18px;background: #3D5DD3;">
              根据全国职业信用评价网入库标准及规定，您的信息已入库，入库编号是
              {{showInfo.code}}
            </td>
          </tr>
        </table>
      </div>
      <div class="box2">
        <div class="theader" style="margin-top:17px;padding-top:39px;">认证项</div>
        <table class="personInfo infosize" style="margin-top:31px">
          <tr class="theader">
            <th style="text-align:center;width: auto;">认证等级</th>
            <th style="text-align:center;padding-left:0;width: auto;">认证名称</th>
            <th style="text-align:center;width: auto;">入库日期</th>
            <th style="text-align:center;padding-left:0;width: auto;">入库类别</th>
          </tr>

          <tr>
            <td style="text-align:center;opacity: 0.64;width: auto;">{{ showInfo.level }}</td>
            <td style="text-align:center;padding-left:0;width: auto;">认证名称</td>
            <td style="text-align:center;opacity: 0.64;width: auto;">{{ showInfo.certtime }}</td>
            <td style="text-align:center;padding-left:0;width: auto;">入库类别</td>
          </tr>
        </table>
      </div>
      <div class="box3">
        <div class="theader" style="margin-top:17px;padding-top:39px">认证内容</div>
        <table class="personInfo infosize" style="margin-top:31px">
          <!-- {
          "isnew": true,
          "_id": "66017f1e43c071c35fe34600",
          "name": "测试",
          "sex": "男",
          "edu": "本科",
          "contacts": "16545453434",
          "cardtype": "身份证",
          "cardtid": "341203200009083433",
          "company": "工作单位",
          "birthday": "2000年09月08日",
          "position": "专业名称",
          "code": "2345678",
          "level": "3",
          "grade": "100",
          "examtime": "2024.03.25",
          "certtime": "2024.03.25",
          "remark": "备注",
          "issuedagency": "发证机关",
          "issuedurl": "机关网站",
          "certid": 2,
          "createdAt": "2024-03-25T13:41:50.337Z",
          "__v": 0
          } -->
          <tr class="theader">
            <th style="text-align:center;width: auto;">培训类型</th>
            <th style="text-align:center;padding-left:0;width: auto;">培训时间</th>
            <th style="text-align:center;width: auto;">培训机构</th>
            <th style="text-align:center;padding-left:0;width: auto;">培训课程</th>
            <th style="text-align:center;width: auto;">培训时长</th>
            <th style="text-align:center;padding-left:0;width: auto;">培训地区</th>
          </tr>
          <tr>
            <td style="text-align:center;opacity: 0.64;width: auto;">培训类型</td>
            <td style="text-align:center;padding-left:0;width: auto;">{{ showInfo.examtime }}</td>
            <td style="text-align:center;opacity: 0.64;width: auto;">培训机构</td>
            <td style="text-align:center;padding-left:0;width: auto;">培训课程</td>
            <td style="text-align:center;opacity: 0.64;width: auto;">培训时长</td>
            <td style="text-align:center;padding-left:0;width: auto;">培训地区</td>
          </tr>
        </table>
      </div>

    </div>
    <!-- <div class="bacc">版权所有：荣誉证书查询网</div> -->
  </div>

</template>

<script>
/**
 * 个人证书查询系统模版
 */
export default {
  name: "ShowGr",
  data() {
    return {
      IP_TEST:'',
      webConfig:null,
      arrSprtQys:[],
      pagenum:1
    }
  },
  props: {
    showInfo: Object
  },
  mounted() {
    this.$axios.get("/api/webConfigs").then(res => {
      if (res.data && res.data.data.length > 0) {
        this.webConfig = res.data.data[0];
      }
    });
    if(this.showInfo.nianjian)
    {
      let arrtmpsprts=this.showInfo.nianjian.split("##");
      for(let i = 0; i < arrtmpsprts.length;i++) {
        this.arrSprtQys[i]={
          title:arrtmpsprts[i].split("||")[0],
          date:arrtmpsprts[i].split("||")[1],
        }
      }
      this.pagenum = Math.ceil( this.arrSprtQys.length/4);
      if(this.pagenum===0)this.pagenum=1;
    }
	// this.creatQrCode(this.showInfo.cardid,this.showInfo.name,this.showInfo.bzcode,this.showInfo.certname);
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    formatExcelData(value) {
      let dataStr = this.formatExcel(value);
      if (isNaN(dataStr) && !isNaN(Date.parse(dataStr))) {
          value = new Date(dataStr);
          if (dataStr.indexOf("/") == -1 && dataStr.indexOf("-") == -1)
              value.setDate(value.getDate() + 1);
          value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
          -2
          )}月${("00" + value.getDate()).slice(-2)}日`;
          return value;
      } else {
          if (dataStr.indexOf("年") > -1) {
              var ttDate = dataStr.match(/\d{4}.\d{1,2}.\d{1,2}/gm).toString();
              ttDate = ttDate.replace(/[^0-9]/gm, "-");
              value = new Date(ttDate);
              value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
              return value;
          } else {
              if (!isNaN(dataStr)) {
                  var data = new Date(1900, 0, dataStr);
                  value = data;
                  value = `${value.getFullYear()}年${("00" + (value.getMonth() + 1)).slice(
              -2
              )}月${("00" + value.getDate()).slice(-2)}日`;
  
                  return value;
              } else {
                  return dataStr;
              }
          }
      }
  },
    formatExcel(value) {
      if (!value) {
          return "";
      } else {
          if (typeof value == "string") {
              return value.trim();
          } else {
              return value.toString().trim();
          }
      }
    }
  }
};
</script>
<style scoped>
.contentbox{
  position: relative;
  width: 100%;
  margin: 0 auto;
  height: 1449px;
  background-image: url(/static/img/jiegugobeijign.png);
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: left bottom;
  overflow: hidden;
}
.contentbox .show{
  position: relative;
  width: 1200px;
  margin: auto;
  margin-top: 37px;
  min-height: 1218px;
}
.show .box{
  position: relative;
  width: 1200px;
  height: 675px;
  background-color: RGBA(88, 122, 206, .6);
}
.show .box3 ,.show .box2{
  position: relative;
  width: 1200px;
  height: 254px;
  background-color: RGBA(88, 122, 206, .5);
}
.toplogo{
  position: relative;
  width: 100%;
  height: 139px;
  margin: auto;
}
.toplogo h1{
  padding-top: 69px;
  font-size: 35px;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 35px;
  text-align: center;
  letter-spacing: 3px;
}
.toplogo h1::after{
  position: absolute;
  left:580px;
  bottom:0px;
  content:'';
  width: 37px;
height: 8px;
background: #4462CF;
border-radius: 3px;
}
.personInfo{
  width:1143px;
  margin: auto;
  /* margin-top: 47px; */
  font-size: 14px;
  border-collapse:collapse;
  border-spacing:0;
  border-left:1px solid #7B93D0;
  border-top:1px solid #7B93D0;
}
.personInfo td{
  color: #FFFFFF;
  border-right:1px solid #7B93D0;
  border-bottom:1px solid #7B93D0;
  /* padding:5px 15px; */
  height: 49px;
  line-height: 54px;
  
  font-size: 14px;
font-weight: 500;
}
.personInfo th{
  border-right: 1px solid #7B93D0;
  border-bottom: 1px solid #7B93D0;
  background: #7A8ED5;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  height: 58px;
  line-height: 24px;
  text-align: center;
  font-size: 18px;
}
.personInfo tr td:nth-child(2n-1){
    width: 530px;
}
.personInfo tr td:nth-child(2n){
  padding-left: 59px;
  width: 605px;
  opacity: 0.64;
}
.infosize tr td{
  height: 58px;
}
.theader{
  position: relative;
  margin:47px auto 0;
  margin-left: 36px;
  width: 1143px;
  height: 24px;
  text-align: left;
  font-weight: bold;
  color: #FFFFFF;
  font-size: 24px;
  line-height: 24px;
  padding-bottom:22px ;
}

.personInfo .title td:nth-child(2n-1){
  width: 25%;
    height: 80px;
    text-align: center;
    padding: 0;
    line-height: 80px;
    color: red;
}
.personInfo .title td:nth-child(2n){
  width: 25%;
    height: 80px;
    text-align: center;
    padding: 0;
    line-height: 80px;
    color: red;
}

.personInfo .date td:nth-child(2n-1){
    height: 40px;
    text-align: center;
    padding: 0;
    line-height: 40px;
    color: red;
}
.personInfo .date td:nth-child(2n){
    text-align: center;
    padding: 0;
    height: 40px;
    line-height: 40px;
    color: red;
}
.bacc{
  position: relative;
  margin-top:61px;
  text-align: center;
height: 14px;
font-size: 14px;
font-family: PingFang SC;
font-weight: 500;
color: #000000;
line-height: 14px;
}
</style>